export enum ListingRequestStatusEnum {
    None = 'None',
    Draft = 'Draft',
    Submitted = 'Submitted',
    StudyInCuration = 'Study In Curation',
    Approved = 'Approved',
    Withdrawn = 'Withdrawn',
}
